import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useKimLhc } from '@/context/KimLhc';
import * as S from './styles';

export function PartialResultBadge(): JSX.Element {
	const { scores } = useKimLhc();

	return (
		<Col span={24}>
			<S.PartialResultWrapper>
				<S.PartialResultContainer>
					<S.PartialResultHeader>{I18n.get('Partial result')}</S.PartialResultHeader>
					<S.PartialResultContent>
						<S.PartialResultLabels>
							<S.PartialResultLabel>{I18n.get('Man')}</S.PartialResultLabel>
							<S.PartialResultDivider />
							<S.PartialResultLabel>{I18n.get('Woman')}</S.PartialResultLabel>
						</S.PartialResultLabels>
						<S.PartialResultValues>
							<S.ResultBadgeDisabled>
								<p>{scores.man ?? '-'}</p>
							</S.ResultBadgeDisabled>
							<S.ResultBadgeDisabled>
								<p>{scores.woman ?? '-'}</p>
							</S.ResultBadgeDisabled>
						</S.PartialResultValues>
					</S.PartialResultContent>
				</S.PartialResultContainer>
			</S.PartialResultWrapper>
		</Col>
	);
}
